export default __webpack_public_path__ + "static/media/mobileAppFramework.6ce67913.md";